import { ObjectIdSchema } from '@racemap/sdk/schema/base';
import { Splitter } from 'antd';
import type { FC } from 'react';
import { useStore } from '../../../store/reducers';
import { filterTrackers } from '../../../store/trackers/trackers_helper';
import { type FilterDropItem, type TrackerDropItem, TrackerDropZone } from '../TrackerDropZone';
import { SampleTrackerTable } from './SampleTrackerTable';
import { TotalTrackerTable } from './TotalTrackerTable';

export const Tables: FC = () => {
  const selectedTotalTrackers = useStore((s) => s.trackers.selectedTrackerIds.total);
  const selectedSampleTrackers = useStore((s) => s.trackers.selectedTrackerIds.sample);
  const trackers = useStore((s) => s.trackers.items);
  const tags = useStore((s) => s.trackers.trackerTags);
  const searchValue = useStore((s) => s.trackers.searchValue);

  const {
    moveTrackersToSample,
    removeTrackersFromSample,
    removeAllTrackersFromSample,
    deselectAllTrackers,
  } = useStore((s) => s.trackers.actions);

  const handleMoveToSample = (item: TrackerDropItem | FilterDropItem) => {
    switch (item.itemType) {
      case 'total-trackers': {
        const ids = item.data.ids;
        moveTrackersToSample(Array.from(ids).map((id) => ObjectIdSchema.parse(id)));
        deselectAllTrackers('total');
        break;
      }
      case 'filter-tree': {
        const filters = new Set<string>();
        filters.add(`/${item.data.key}`);
        const filteredTrackers = filterTrackers(trackers, searchValue, filters, tags);

        moveTrackersToSample(filteredTrackers.map((tracker) => tracker.id));
      }
    }
  };
  const handleRemoveFromSample = (item: TrackerDropItem) => {
    const ids = item.data.ids;
    if (ids.size > 0) {
      removeTrackersFromSample(Array.from(ids).map((id) => ObjectIdSchema.parse(id)));
    } else {
      removeAllTrackersFromSample();
    }
    deselectAllTrackers('sample');
  };

  return (
    <Splitter layout="vertical">
      <Splitter.Panel>
        <TrackerDropZone
          acceptedElementIds={['total-trackers', 'filter-tree']}
          onDrop={(item) => handleMoveToSample(item)}
          withIsOver
        >
          <SampleTrackerTable />
        </TrackerDropZone>
      </Splitter.Panel>
      <Splitter.Panel>
        <TrackerDropZone
          acceptedElementIds={['sample-trackers']}
          onDrop={(item) => handleRemoveFromSample(item as TrackerDropItem)}
          withIsOver
        >
          <TotalTrackerTable
            onMoveToSample={() =>
              handleMoveToSample({
                itemType: 'total-trackers',
                data: { ids: selectedTotalTrackers },
              })
            }
            onRemoveFromSample={() =>
              handleRemoveFromSample({
                itemType: 'sample-trackers',
                data: { ids: selectedSampleTrackers },
              })
            }
          />
        </TrackerDropZone>
      </Splitter.Panel>
    </Splitter>
  );
};
